import { Injectable } from '@angular/core';
import { ServiceLevelConfigurationGroup } from '../models/service-level-configuration-group.model';
import { SavedServiceLevelConfigurationModel } from '../models/service-level-configuration.model';

@Injectable({
    providedIn: 'root'
})
export class ServiceLevelConfiguratinoGroupingService {
    public groupServiceLevelConfigByServiceLevel(configs: SavedServiceLevelConfigurationModel[]): ServiceLevelConfigurationGroup[] {
        const serviceLevelConfigurationGroup: ServiceLevelConfigurationGroup[] = [];
        const map: {[key: number]: SavedServiceLevelConfigurationModel[]} = {};
        configs.forEach(config => {
            if (map[config.serviceLevelId]) {
                map[config.serviceLevelId].push(config);
            } else {
                map[config.serviceLevelId] = [];
                map[config.serviceLevelId].push(config);
            }
        });
        Object.keys(map).forEach(key => {
            const id = Number(key);
            serviceLevelConfigurationGroup.push(new ServiceLevelConfigurationGroup(map[id]));
        });
        return serviceLevelConfigurationGroup;
    }
}
